<template>
  <div class="componentBox">
    <h2 class="componentTitle">饲养信息</h2>
    <h3 class="littleTitle">饲养信息</h3>
    <Cell :colList="feedInfoCell" :detail="poultryLineEggFeedInfo" />
    <Cell :colList="feedInfoCell2" :detail="poultryLineEggFeedInfo" :len="2"/>
    <h3 class="littleTitle">生长性能</h3>
    <Cell :colList="productionResultsCell" :detail="poultryLineEggProductResult" :len="2"/>
  </div>
</template>

<script>
import Cell from './Cell.vue';
export default {
  components: {Cell},
  props: ['detail'],
  data() {
    return {
      feedInfoCell: [
        {title: '饲养品种',field: 'feedVariety',},
        {title: '饲料品牌',field: 'feedBrand',},
        {title: '产品名称',field: 'productName',},
        {title: 'NHModel名称',field: 'modelName',},
        {title: 'NHModel代码',field: 'modelCode',},
        {title: '饲料终端价格（元/kg）',field: 'feedPrice',},
      ],
      feedInfoCell2: [
        {title: '入栏数量（只）',field: 'intoNum',},
        {title: '死淘数量（只）',field: 'dieNum',},
        {title: '开始日龄（天）',field: 'intoDayAge',},
        {title: '结束日龄（天）',field: 'outDayAge',},
        {title: '出栏体重（斤/只）',field: 'outWeight',},
        {title: '阶段总产蛋数（枚）',field: 'totalEggNum',},
        {title: '阶段总产蛋量（斤）',field: 'totalEggWeight',},
        {title: '不合格蛋（枚）',field: 'substandardEggNum',},
        {title: '阶段总耗料（斤）',field: 'feedCost',},
      ],
      productionResultsCell: [
        {title: '死淘率（%）',field: 'dieRate',},
        {title: '产蛋率（%）',field: 'eggRate',},
        {title: '不合格蛋率（%）',field: 'substandardEggRate',},
        {title: '料蛋比',field: 'weightCostRatio',},
        {title: '日均采食（g/只）',field: 'avgDayFeed',},
        {title: '日均只产蛋量（g/只）',field: 'avgDayEgg',},
        {title: '平均蛋重（g/枚）',field: 'avgEggWeight',},
        {title: '斤蛋成本（元/斤）',field: 'avgEggCost',},
      ],
      staffId:''
    }
  },
  watch: {
    // detail:{
    //   handler(){
    //     this.feedDetail()
    //   },
    //   deep: true
    // }
  },
  computed: {
    poultryLineEggFeedInfo(){
      return this.detail.poultryLineEggFeedInfo || []
    },
    poultryLineEggProductResult(){
      return this.detail.poultryLineEggProductResult || []
    },
  },
  created() {},
  mounted() {this.staffId=window.localStorage.getItem('staffId')},
  methods: {
    productDetail(record){
      this.$router.push({
        path: '/nhf-compound-editor',
        query: {
          id: record.nhfFormulaId
        }
      })
    }
  },
}
</script>
<style lang='scss'></style>
<style lang='scss' scoped></style>